// ////////////////////////////////////////////////////////////
// Riot mixin containing tools for formatting phone numbers //
// ////////////////////////////////////////////////////////////

export default {
  /**
  * Takes a 10 digit number and returns it in the format `(123) 456-7890`
  * @param  {Integer} pNum The phone number to be converted.
  * @return {String}      Formatted US phone number.
  */
  format_us(pNum) {
    const s2 = (`${pNum}`).replace(/\D/g, '')
    const m = s2.match(/^(\d{3})(\d{3})(\d{4})$/)
    return (!m) ? null : `(${m[1]}) ${m[2]}-${m[3]}`
  },
}
